<h2
    mat-dialog-title
    class="tt-secondary-background"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragBoundary=".cdk-overlay-container"
    cdkDragHandle
    style="color: white"
    ttTranslateWord="configure_multiple_lines"
></h2>
<mat-dialog-content style="display: flex; flex-direction: column; height: 100%; max-height: none">
    <ng-container *ngIf="!!get">
        <tt-tabs [(ttSelectedId)]="get.selected_tab">
            <tt-tab *ngIf="get.show_models_tab === '1'" ttId="SELECTMODEL" ttLabel="select_model"></tt-tab>
            <tt-tab ttId="SELECTPRODUCTS" ttLabel="select_products" [ttDisabled]="!selectProductsParams"></tt-tab>
            <tt-tab ttId="PRODUCTSCONFIG" ttLabel="p2_m_productsconfig" [ttDisabled]="!selectProducts.submitted"></tt-tab>
        </tt-tabs>
        <tt-select-line-model [hidden]="get.selected_tab !== 'SELECTMODEL'" *ngIf="get.show_models_tab === '1'" [params]="get" (submit)="onModelSubmit($event)"></tt-select-line-model>
        <tt-select-line-products #selectProducts [hidden]="get.selected_tab !== 'SELECTPRODUCTS'" [params]="selectProductsParams" (submit)="onProductsSubmit($event)"></tt-select-line-products>
        <tt-products-config *ngIf="selectProducts.submitted" [hidden]="get.selected_tab !== 'PRODUCTSCONFIG'" [params]="productsConfigParams" (submit)="onConfigurationSubmit()"></tt-products-config>
    </ng-container>
</mat-dialog-content>
